import { SeverityColour } from "core/enums";

/**
 * returns the a css colour string for the specified severity colour
 * @param colourName the name of the colour to convert into hexadecimal
 * @returns {string} hexadecimal string
 */
export const getSeverityColour = colourName => {
  switch (colourName) {
    case SeverityColour.GRAY:
      return "Gray";
    case SeverityColour.GREEN:
      return "#4CAF50";
    case SeverityColour.BLUE:
      return "#2196F3";
    case SeverityColour.YELLOWGREEN:
      return "#ffc30b";
    case SeverityColour.YELLOW:
      return "#FF9800";
    case SeverityColour.RED:
      return "#F44336";
    default:
      throw new Error(`unhandled colour name: ${colourName}`);
  }
};
